import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const battleOfSoulsQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow Battle of Souls",
    caption: "Get exclusive content and updates",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-wishlist-added",
    ruleId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Game Trailer",
    caption: "Discover the epic world of Battle of Souls",
    videoMimeType: "iframe/embed",
    videoUrl: "https://youtu.be/UNvfUijtTo4",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-trailer-event",
    ruleId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    skippable: true,
    caption: "Stay updated with the latest news and events",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-twitter-event",
    ruleId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord Community",
    caption: "Connect with players and join the discussion",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-discord-event",
    ruleId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-discord",
    linkUrl: "https://discord.gg/Q9d72jEdyv",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download the game",
    caption: "Play the game and earn rewards",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-website-event",
    ruleId: "01ed155f-637e-4940-9ff8-d9d9519d6d75-website",
    linkUrl:
      "https://play.google.com/store/apps/details?id=com.pxlr.battleofsouls&hl=en",
  },
];

export const battleOfSoulsQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 50,
    quests: battleOfSoulsQuestsList,
  },
];
